module.exports = __webpack_public_path__ + "img/logo-iee.7c679026.png";